import { Injectable } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';
import { LambdaClient, InvokeCommand } from '@aws-sdk/client-lambda';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClientLambdaService {
  constructor() {}

  // shared lambda code to invoke lambda ( Note to make it reuseable instead of code copy paste)
  /**
   *
   * @param functionName name of lambda/function in backend to invoke
   * @param event  an object send as input to lambda
   * @returns response from lambda
   */
  async invokeLambda(functionName: string, event: any, invocationType = null, defaultTimeOut = 120000): Promise<any> {
    const { credentials } = await fetchAuthSession();
    // add region and credentials for access permission to execute lambda
    const client = new LambdaClient({
      credentials,
      region: environment.region,
      requestHandler: {
        metadata: { timeout: defaultTimeOut }, // default timeout
      },
    });
    // Information which will be send as parameters like event.json in lambda
    const params = invocationType
      ? {
          FunctionName: `${functionName}-${environment.name}`,
          Payload: JSON.stringify(event),
          InvocationType: invocationType,
        }
      : {
          FunctionName: `${functionName}-${environment.name}`,
          Payload: JSON.stringify(event),
        };
    // Invoking lambda
    try {
      const command = new InvokeCommand(params);
      const result = await client.send(command);
      return result;
    } catch (e) {
      return null;
    }
  }
}
